import { css } from '@emotion/react';
import styled from '@emotion/styled';
import FONT from '../../styles/emotion/fonts';
import COLORS, { COLORS_BUTTONS } from '../../styles/emotion/colors3';
import MEDIA_QUERY_V2 from '../../styles/emotion/mediaQueryV2';
import Arrow from '../SvgIcons/Arrow';
import { SPACING, utils } from '../../styles/emotion';

export const StyledNav = styled.nav<{ scrollOnMobile: boolean }>`
  ${({ scrollOnMobile }) => {
    return scrollOnMobile
      ? css`
          ${MEDIA_QUERY_V2.MOBILE} {
            position: relative;
            width: 100vw;

            &::after {
              content: '';
              position: absolute;
              top: 0;
              right: 0;
              height: 100%;
              width: 40px;
              background-image: linear-gradient(to right, transparent, ${COLORS_BUTTONS.CLOUD_050});
              pointer-events: none;
            }
          }
        `
      : null;
  }}
`;
export const ArrowIcon = styled(Arrow)`
  color: ${COLORS.BLACK_075};
  margin-right: 8px;
  &:hover {
    color: ${COLORS.BLACK_075};
  }
`;

export const BackLink = styled.a`
  font-size: ${FONT.FONT_SIZE_EXTRA_SMALL};
  font-weight: ${FONT.FONT_WEIGHT_REGULAR};
  line-height: 24px;
  color: ${COLORS.BLACK_075};
  display: flex;
  align-items: center;
  &:hover {
    color: ${COLORS.BLACK_075};
  }
`;

export const MobileOnlyBackLink = styled(BackLink)`
  display: none;

  ${MEDIA_QUERY_V2.MOBILE} {
    display: flex;
  }
`;

const breadcrumbItemStyles = css`
  font-size: ${FONT.FONT_SIZE_EXTRA_SMALL};
  font-weight: ${FONT.FONT_WEIGHT_REGULAR};
  line-height: 22px;
`;

export const LinkItem = styled.a<{ disableBackLink: boolean }>`
  ${breadcrumbItemStyles}
  ${({ disableBackLink }) => {
    return disableBackLink
      ? null
      : css`
          ${MEDIA_QUERY_V2.MOBILE} {
            display: none;
          }
        `;
  }}
  color: ${COLORS.BLACK_075};
  text-decoration: underline;
  &:hover {
    color: ${COLORS.BLACK_075};
    text-decoration: underline;
  }
`;

export const Divider = styled.span<{ disableBackLink: boolean }>`
  ${breadcrumbItemStyles}
  ${({ disableBackLink }) => {
    return disableBackLink
      ? null
      : css`
          ${MEDIA_QUERY_V2.MOBILE} {
            display: none;
          }
        `;
  }}
  color: ${COLORS.BLACK_030};
  margin: 0 8px;
`;

export const TextItem = styled.span<{ disableBackLink: boolean }>`
  ${breadcrumbItemStyles}
  ${({ disableBackLink }) => {
    return disableBackLink
      ? null
      : css`
          ${MEDIA_QUERY_V2.MOBILE} {
            display: none;
          }
        `;
  }}
  color: ${COLORS.BLACK_075};
`;

export const InnerList = styled.ul<{ scrollOnMobile: boolean }>`
  padding: 0;
  margin: 0;
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;

  ${MEDIA_QUERY_V2.MOBILE} {
    flex-wrap: ${(props) => (props.scrollOnMobile ? 'nowrap' : 'wrap')};
    overflow: ${(props) => (props.scrollOnMobile ? 'scroll' : 'auto')};
    width: ${(props) => (props.scrollOnMobile ? '100vw;' : 'auto')};
    ${utils.concealScrollbars}
  }
`;

export const InnerListItem = styled.li<{ scrollOnMobile: boolean }>`
  padding: 0;
  margin: 0;
  ${MEDIA_QUERY_V2.MOBILE} {
    width: ${(props) => (props.scrollOnMobile ? 'auto' : '100%')};
    white-space: ${(props) => (props.scrollOnMobile ? 'nowrap' : 'auto')};

    &:last-of-type {
      margin-right: ${SPACING.LG};
    }
  }
`;
